import React, { Component } from "react";
import { withAppData } from "../../app/withAppData";
import { API_BASE_URL } from "../../api/config";
import PolicyRepository from "../../api/modules/policy/repo";
class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        name: "",
        email: "",
        phone: "",
        service: "",
        message: "",
        agree: false,
      },
      isSubmitting: false,
      submitMessage: "",
      showKvkkModal: false,
      kvkkContent: null,
      loadingKvkk: false,
    };
  }

  handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: type === "checkbox" ? checked : value,
      },
    }));
  };

  getEmailByServiceId = (serviceId, config) => {
    // Service ID'ye göre email adresini belirle
    const serviceMap = {
      "689c85e5fc299d03398bc275": config.repairServiceEmail, // Bakım-Servis (TR)
      "689c85e5fc299d03398bc276": config.boughtServiceEmail, // Satın Alma (TR)
      "689c85e5fc299d03398bc277": config.sellerServiceEmail, // Satış (TR)
      "689c85e5fc299d03398bc278": config.repairServiceEmail, // Service (EN)
      "689c85e5fc299d03398bc279": config.boughtServiceEmail, // Purchasing (EN)
      "689c85e5fc299d03398bc27a": config.sellerServiceEmail, // Sales (EN)
    };

    return serviceMap[serviceId] || config.sellerServiceEmail; // Default to sales
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { lang, pageConfig } = this.props.appData;
    const config = pageConfig?.contact?.settings?.translations?.[lang] || {};

    // Form validation
    if (
      !this.state.formData.name ||
      !this.state.formData.email ||
      !this.state.formData.service ||
      !this.state.formData.message
    ) {
      this.setState({
        submitMessage:
          lang === "tr"
            ? "Lütfen tüm alanları doldurun."
            : "Please fill in all fields.",
      });
      return;
    }

    if (!this.state.formData.agree) {
      this.setState({
        submitMessage:
          lang === "tr"
            ? "KVKK metnini onaylamanız gerekiyor."
            : "You must agree to the privacy policy.",
      });
      return;
    }

    this.setState({ isSubmitting: true, submitMessage: "" });

    try {
      const targetEmail = this.getEmailByServiceId(
        this.state.formData.service,
        config,
      );
      const selectedService = config.listItems?.find(
        (item) => item._id === this.state.formData.service,
      );

      // Form verilerini hazırla (Backend DTO yapısına uygun olarak)
      const emailData = {
        to: "kadirr1574@gmail.com",
        subject: `İletişim Formu - ${this.state.formData.name}`,
        name: this.state.formData.name,
        email: this.state.formData.email,
        phone: this.state.formData.phone,
        service: selectedService?.title || "Belirtilmemiş",
        message: this.state.formData.message,
      };

      await fetch(`${API_BASE_URL}/mail/send`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(emailData),
      });

      // Simulated success for now
      this.setState({
        submitMessage:
          lang === "tr"
            ? "Mesajınız başarıyla gönderildi!"
            : "Your message has been sent successfully!",
        formData: {
          name: "",
          email: "",
          phone: "",
          service: "",
          message: "",
          agree: false,
        },
      });
    } catch (error) {
      console.error("Form submission error:", error);
      this.setState({
        submitMessage:
          lang === "tr"
            ? "Mesaj gönderilirken hata oluştu. Lütfen tekrar deneyin."
            : "An error occurred while sending the message. Please try again.",
      });
    } finally {
      this.setState({ isSubmitting: false });
    }
  };

  handleKvkkClick = async (e) => {
    e.preventDefault();
    const { lang } = this.props.appData;

    this.setState({ showKvkkModal: true, loadingKvkk: true });

    try {
      const policyData = await PolicyRepository.getAllPolicies(lang);
      const kvkkContent =
        policyData?.dataProtectionNotice?.data?.translations?.[lang]?.content ||
        "KVKK metni bulunamadı.";
      this.setState({ kvkkContent, loadingKvkk: false });
    } catch (error) {
      console.error("KVKK content fetch error:", error);
      this.setState({
        kvkkContent: "KVKK metni yüklenirken hata oluştu.",
        loadingKvkk: false,
      });
    }
  };

  closeKvkkModal = () => {
    this.setState({ showKvkkModal: false, kvkkContent: null });
  };

  render() {
    const { lang, pageConfig } = this.props.appData;
    const config = pageConfig?.contact?.settings?.translations?.[lang] || {};
    const {
      formData,
      isSubmitting,
      submitMessage,
      showKvkkModal,
      kvkkContent,
      loadingKvkk,
    } = this.state;

    return (
      <div className="ltn__contact-message-area mb-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="ltn__form-box contact-form-box box-shadow white-bg">
                <h4 className="title-2">{config.title || "İletişim"} Form</h4>
                <form onSubmit={this.handleSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="input-item input-item-name ltn__custom-icon">
                        <input
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={this.handleInputChange}
                          placeholder={config.name || "Ad-Soyad"}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-item input-item-email ltn__custom-icon">
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={this.handleInputChange}
                          placeholder={config.email || "E-posta Adresiniz"}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-item">
                        <select
                          name="service"
                          value={formData.service}
                          onChange={this.handleInputChange}
                          className="form-control no-niceselect"
                          required
                          style={{
                            height: "55px",
                            borderRadius: "6px",
                            border: "1px solid #ddd",
                            paddingLeft: "12px",
                          }}
                        >
                          <option value="">
                            {lang === "tr"
                              ? "Servis Tipi Seçin"
                              : "Select Service Type"}
                          </option>

                          {config.listItems && config.listItems.length > 0
                            ? config.listItems.map((item) => (
                                <option key={item._id} value={item._id}>
                                  {item.title}
                                </option>
                              ))
                            : null}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-item input-item-phone ltn__custom-icon">
                        <input
                          type="text"
                          name="phone"
                          value={formData.phone}
                          onChange={this.handleInputChange}
                          placeholder={config.phone || "Telefon Numaranız"}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="input-item input-item-textarea ltn__custom-icon">
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={this.handleInputChange}
                      placeholder={config.message || "Mesajınız"}
                      required
                    />
                  </div>
                  <p>
                    <label className="input-info-save mb-0">
                      <input
                        type="checkbox"
                        name="agree"
                        checked={formData.agree}
                        onChange={this.handleInputChange}
                        required
                      />
                      <button
                        type="button"
                        onClick={this.handleKvkkClick}
                        style={{
                          background: "none",
                          border: "none",
                          textDecoration: "underline",
                          color: "#007bff",
                          cursor: "pointer",
                          padding: 0,
                          font: "inherit",
                        }}
                      >
                        {lang === "tr" ? "KVKK metnini" : "privacy policy"}
                      </button>
                      {lang === "tr"
                        ? " okudum ve onaylıyorum."
                        : " I have read and agree to the ."}
                    </label>
                  </p>
                  <div className="btn-wrapper mt-0">
                    <button
                      className="btn theme-btn-1 btn-effect-1 text-uppercase"
                      type="submit"
                      disabled={isSubmitting}
                    >
                      {isSubmitting
                        ? lang === "tr"
                          ? "Gönderiliyor..."
                          : "Sending..."
                        : config.buttonText || "Mesaj Gönder"}
                    </button>
                  </div>
                  {submitMessage && (
                    <p
                      className={`form-messege alert alert-success mb-0 mt-20 ${
                        submitMessage.includes("başarıyla") ||
                        submitMessage.includes("successfully")
                          ? "success"
                          : "error"
                      }`}
                    >
                      {submitMessage}
                    </p>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* KVKK Modal */}
        {showKvkkModal && (
          <div
            className="modal fade show"
            style={{
              display: "block",
              backgroundColor: "rgba(0,0,0,0.5)",
              zIndex: 9999,
            }}
          >
            <div className="modal-dialog modal-lg">
              <div className="modal-content p-3">
                <div className="modal-header p-2">
                  <h5 className="modal-title">
                    {lang === "tr" ? "KVKK Metni" : "Privacy Policy"}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={this.closeKvkkModal}
                    style={{
                      background: "none",
                      border: "none",
                      fontSize: "24px",
                      cursor: "pointer",
                    }}
                  >
                    ×
                  </button>
                </div>
                <hr className="my-2" />
                <div
                  className="modal-body"
                  style={{ maxHeight: "400px", overflowY: "auto" }}
                >
                  {loadingKvkk ? (
                    <div className="text-center">
                      <p>{lang === "tr" ? "Yükleniyor..." : "Loading..."}</p>
                    </div>
                  ) : (
                    <div dangerouslySetInnerHTML={{ __html: kvkkContent }} />
                  )}
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={this.closeKvkkModal}
                  >
                    {lang === "tr" ? "Kapat" : "Close"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withAppData(ContactForm);
